import animateCSS from "./animations";
import { renderValidationErrors, showRequestError } from "./utils";

import events from "dom-helpers/events";

import createRelationshipTemplate from "../templates/relationships/create.handlebars";

export function destroyRelationshipDataHandler() {
  const elem = document.getElementById("wichtel_list");
  if (elem !== null && typeof elem !== "undefined") {
    events.on(
      elem,
      "ajax:beforeSend",
      events.filter("a.destroy", (event) => {
        let parent = event.target.closest("li[data-param]");
        if (!parent || !event.detail || !event.detail[0]) return;
        event.detail[0].setRequestHeader("X-Wichtelomat-Relationship", `${parent.dataset.param}:${parent.dataset.partner}`);
      })
    );
  }
}

export function destroyRelationshipHandler() {
  const elem = document.getElementById("wichtel_list");
  if (elem !== null && typeof elem !== "undefined") {
    events.on(
      elem,
      "ajax:success",
      events.filter("a.destroy", (event) => {
        const sourceElement = event.target.closest("li");
        if (!sourceElement) return;
        const targetElem = Array.from(elem.querySelectorAll("li[data-param]")).find(
          (node) => node.dataset.param === sourceElement.dataset.partner
        );
        for (const participant of [sourceElement, targetElem]) {
          if (!participant) continue;
          delete participant.dataset.partner;
          const information = participant.querySelector(".partner-information");
          if (information) animateCSS(information, "fadeOut", (node) => node.remove());

          document.querySelectorAll("#relationship_relationship_source, #relationship_relationship_target").forEach((select) => {
            if (!Array.from(select.options).some((option) => option.value === participant.dataset.param)) {
              select.appendChild(new Option(participant.dataset.name, participant.dataset.param));
            }
          });
        }

        if (document.querySelectorAll("#relationship_relationship_source > option").length > 2) {
          animateCSS("#new_relationship", "fadeIn");
        }
      })
    );
  }
}

export function createRelationshipHandler() {
  const elem = document.getElementById("new_relationship");
  if (elem !== null && typeof elem !== "undefined") {
    events.on(elem, "ajax:success", (event) => {
      if (!Array.isArray(event.detail) || !event.detail[0] || !event.detail[0].relationship) {
        showRequestError("server");
        return;
      }
      let relationship = event.detail[0].relationship;

      let sourceElem = document.querySelector("#relationship_relationship_source option:checked");
      let targetElem = document.querySelector("#relationship_relationship_target option:checked");
      if (!sourceElem || !targetElem || typeof relationship.path !== "string") {
        showRequestError("server");
        return;
      }

      let sourceData = {
        partner: sourceElem.innerHTML,
        partner_id: sourceElem.value,
        id: targetElem.value,
        path: relationship.path,
      };

      let targetData = {
        partner: targetElem.innerHTML,
        partner_id: targetElem.value,
        id: sourceElem.value,
        path: relationship.path,
      };

      let sourceItem = document.querySelector(`#wichtel_list > li[data-param="${sourceData.id}"]`);
      let targetItem = document.querySelector(`#wichtel_list > li[data-param="${targetData.id}"]`);
      if (!sourceItem || !targetItem) {
        showRequestError("server");
        return;
      }

      sourceItem.insertAdjacentHTML("beforeend", createRelationshipTemplate(sourceData));
      sourceItem.dataset.partner = sourceData.partner_id;

      targetItem.insertAdjacentHTML("beforeend", createRelationshipTemplate(targetData));
      targetItem.dataset.partner = targetData.partner_id;

      elem.querySelectorAll("span.error").forEach((node) => {
        node.remove();
      });

      elem.querySelectorAll("option").forEach((option) => {
        if (option.value === sourceData.partner_id || option.value === targetData.partner_id) {
          option.parentNode.removeChild(option);
        }
      });

      if (document.querySelectorAll("#relationship_relationship_source > option").length <= 2) {
        animateCSS(elem, "fadeOut", (node, _animationName) => {
          node.style.display = "none";
        });
      }

      elem.reset();
    });
  }
}

export function createRelationshipErrorHandler() {
  const elem = document.getElementById("new_relationship");
  if (elem !== null && typeof elem !== "undefined") {
    events.on(elem, "ajax:error", (event) => {
      event.validationErrorsRendered = renderValidationErrors(event, elem, "relationship");
    });
  }
}

export function relationshipSelectPartnerHandler() {
  document.querySelectorAll("#new_relationship select").forEach((elem) => {
    events.on(elem, "change", (event) => {
      let select = event.target;
      let selected = select.querySelector("option:checked");

      document.querySelectorAll(`#new_relationship select:not([id="${select.id}"]) > option`).forEach((option) => {
        if (option.value !== "") {
          option.disabled = option.value === selected.value;
        }
      });
    });
  });
}

export function showRelationshipForm() {
  const elem = document.querySelector("form.new_relationship");
  const optionsList = document.querySelectorAll("#relationship_relationship_source > option");
  if (elem !== null && elem !== undefined && optionsList.length > 2) {
    elem.style.display = "block";
  }
}
